import { axiosInstance } from './httpClient';
import { API } from './env';

export default class PromotionsApi {
  static getAuthConfig = () => {
    let userInfo = JSON.parse(localStorage.getItem('user'));
    let accessToken = userInfo.token;

    return {
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + accessToken,
      },
    };
  };

  static getAllPromotions = () => {
    return axiosInstance.get(`${API}/promotions`, this.getAuthConfig());
  };

  static getPromotionById = (id) => {
    return axiosInstance.get(`${API}/promotions/${id}`, this.getAuthConfig());
  };

  static createPromotion = (promotionData) => {
    return axiosInstance.post(
      `${API}/promotions`,
      JSON.stringify(promotionData),
      this.getAuthConfig(),
    );
  };

  static updatePromotion = (id, promotionData) => {
    return axiosInstance.put(
      `${API}/promotions/${id}`,
      JSON.stringify(promotionData),
      this.getAuthConfig(),
    );
  };

  static deletePromotion = (id) => {
    return axiosInstance.delete(`${API}/promotions/${id}`, this.getAuthConfig());
  };
}
